import { PagePreference } from './page-preference'
import { PagePreferenceQuery } from './page-preference-query'
import { PagePreferenceMutation } from './page-preference-mutation'

export const entities = [PagePreference]
export const resolvers = [PagePreferenceQuery, PagePreferenceMutation]
